import moment from "moment";
import * as React from "react";
import * as ISC from "../../../Details/InfoTable/styles";

import { constructStrRep } from "../../../../store/calendar";

import { BooleanLabel, DurationCell } from "../../../Displays";
import { GenericCell, TimeCell } from "../../../Displays";

export default ({ instance }) => {
  return (
    <ISC.InfoTable>
      {/* <ISC.InfoTableTitleWrapper>
        <ISC.InfoTableTitle>
          <ISC.InfoTableTitle>
            {instance?.title ? instance.title : "Titel saknas"}
          </ISC.InfoTableTitle>
          <ISC.InfoTableSubtitle>Titel</ISC.InfoTableSubtitle>
        </ISC.InfoTableTitle>
      </ISC.InfoTableTitleWrapper> */}

      <ISC.InfoTableContent>
        <ISC.InfoTableRow>
          <ISC.InfoTableRowTitle>Titel</ISC.InfoTableRowTitle>
          <ISC.InfoTableRowValue>
            {instance?.title ? instance.title : "Titel saknas"}
          </ISC.InfoTableRowValue>
        </ISC.InfoTableRow>

        <ISC.InfoTableRow>
          <ISC.InfoTableRowTitle>Kalender</ISC.InfoTableRowTitle>
          <ISC.InfoTableRowValue>
            {instance?.calendar
              ? constructStrRep(instance.calendar)
              : "Kalender saknas"}
          </ISC.InfoTableRowValue>
        </ISC.InfoTableRow>

        <ISC.InfoTableRow>
          <ISC.InfoTableRowTitle>Beskrivning</ISC.InfoTableRowTitle>
          <ISC.InfoTableRowValue>
            {instance?.description
              ? instance.description
              : "Beskrivning saknas"}
          </ISC.InfoTableRowValue>
        </ISC.InfoTableRow>

        <ISC.InfoTableRow>
          <ISC.InfoTableRowTitle>Start</ISC.InfoTableRowTitle>
          <ISC.InfoTableRowValue>
            {instance?.start ? (
              <TimeCell date={instance.start} />
            ) : (
              "Starttid saknas"
            )}
          </ISC.InfoTableRowValue>
        </ISC.InfoTableRow>

        <ISC.InfoTableRow>
          <ISC.InfoTableRowTitle>Slut</ISC.InfoTableRowTitle>
          <ISC.InfoTableRowValue>
            {instance?.end ? (
              <TimeCell date={instance.end} />
            ) : (
              "Sluttid saknas"
            )}
          </ISC.InfoTableRowValue>
        </ISC.InfoTableRow>

        <ISC.InfoTableRow>
          <ISC.InfoTableRowTitle>Kopplat objekt</ISC.InfoTableRowTitle>
          <ISC.InfoTableRowValue>
            {instance?.object_id && instance.content_type ? (
              <GenericCell
                contentType={instance.content_type}
                id={instance.object_id}
              />
            ) : (
              "Objekt saknas"
            )}
          </ISC.InfoTableRowValue>
        </ISC.InfoTableRow>

        <ISC.InfoTableRow>
          <ISC.InfoTableRowTitle>Plats</ISC.InfoTableRowTitle>
          <ISC.InfoTableRowValue>
            {instance?.place ? instance.place.base : "Plats saknas"}
          </ISC.InfoTableRowValue>
        </ISC.InfoTableRow>
      </ISC.InfoTableContent>
    </ISC.InfoTable>
  );
};
